import React, { useEffect } from "react";
import cn from "../../lib/utils/class-name";
import { useLocation } from "react-router";
import { useModal } from "../../hooks/useModal";

export default function GlobalModal() {
  const { isOpen, view, closeModal } = useModal();
  const pathname = useLocation().pathname;
  useEffect(() => {
    closeModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const shouldShow = isOpen ? "block" : "hidden";
  return (
    <div
      className={`fixed cursor-pointer flex place-items-center justify-center animate-easeIn bg-black bg-opacity-40 top-0 left-0 w-full h-lvh z-[9999] backdrop-blur-[10px] ${shouldShow}`}
      onClick={closeModal}
    >
      <div
        className={cn(`absolute cursor-auto transition-transform`)}
        onClick={(e) => e.stopPropagation()}
      >
        {view}
      </div>
    </div>
  );
}
